"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/components/theme-provider";
import { SM_THEME_PARAM } from "@/lib/platform/themeSync";
import { AppearanceSync } from "@/components/platform/appearance";
import React from "react";

// Create a single shared QueryClient instance
const queryClient = new QueryClient();

// After a cross-app hop, strip ?sm_theme from the URL so it doesn't linger in the
// address bar or get re-applied on a later same-origin navigation. The pre-paint script
// in the root layout has already consumed it into localStorage by the time this runs.
function SmThemeParamCleanup() {
  React.useEffect(() => {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has(SM_THEME_PARAM)) {
        url.searchParams.delete(SM_THEME_PARAM);
        window.history.replaceState({}, "", url.pathname + url.search + url.hash);
      }
    } catch {
      /* no-op */
    }
  }, []);
  return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <SmThemeParamCleanup />
        <AppearanceSync />
        {children}
      </ThemeProvider>
    </QueryClientProvider>
  );
}
